module.exports = __webpack_public_path__ + "static/media/atagi-covid-news.13b322e3.jpg";